import RPMCarePlansTable from './rpm-care-plans-table';
import './style.css';

export default RPMCarePlansTable;
